module.exports = __webpack_public_path__ + "static/media/Logo-teamaltona-RGB_weiss.9ff13832.png";